import { render, staticRenderFns } from "./InspectionItemsForm.vue?vue&type=template&id=56c8c8c8&scoped=true"
import script from "./InspectionItemsForm.vue?vue&type=script&lang=js"
export * from "./InspectionItemsForm.vue?vue&type=script&lang=js"
import style0 from "./InspectionItemsForm.vue?vue&type=style&index=0&id=56c8c8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8c8c8",
  null
  
)

export default component.exports